module.exports = __webpack_public_path__ + "static/media/etherum.73bbf767.png";